import { SORTS } from "./sorts";
import { WIDGETS } from "./widgets";
import { FILTER_NAMES } from "./filters";

export const CLIENT_CONFIG_DEFAULT_WIDGET_OPTIONS = {
  base: {
    phoneOffer: {
      collapsibleResults: false,
      collapsibleResultsLimit: 5,
      filters: {
        mainFilters: [FILTER_NAMES.price],
        mobileFilters: [FILTER_NAMES.price],
        secondaryFilters: [
          FILTER_NAMES.brand,
          FILTER_NAMES.phoneOperatingSystem,
          { name: FILTER_NAMES.offerExtraGroups, order: [] }
        ]
      },
      fullComparatorUrl: null,
      initialFilter: {
        brandId: [],
        inStock: null,
        isIndependent: null,
        limit: 50,
        maxPrice: 2000,
        offerExtraId: [],
        phoneCategoryId: [],
        phoneId: [],
        phoneOperatingSystemId: [],
        phoneVariantId: [],
        shopId: []
      },
      initialShow: false,
      initialSort: SORTS.popular,
      extraOfferLineIds: [],
      pagination: true,
      paginationPerPage: 10,
      preSelectPhoneFromPhoneGroup: false,
      show: false
    },
    proposition: {
      collapsibleResults: false,
      collapsibleResultsLimit: 5,
      filters: {
        mainFilters: [
          FILTER_NAMES.dataCredits,
          FILTER_NAMES.voiceCredits,
          FILTER_NAMES.price
        ],
        mobileFilters: [FILTER_NAMES.dataCredits, FILTER_NAMES.price],
        secondaryFilters: [
          FILTER_NAMES.monthlyFee,
          FILTER_NAMES.providers,
          FILTER_NAMES.currentProvider,
          { name: FILTER_NAMES.offerExtraGroups, order: [] },
          FILTER_NAMES.contractTermInMonths,
          FILTER_NAMES.dataSpeedDown
        ]
      },
      fullComparatorUrl: null,
      initialFilter: {
        brandId: [],
        contractTermInMonths: [],
        currentProviderId: null,
        dataSpeedGen: [],
        inStock: null,
        isIndependent: null,
        isRetention: false,
        limit: 20,
        maxMonthlyFee: 150,
        maxPrice: 300,
        minDataCredits: 1000,
        minDataSpeedDown: 0,
        minSmsCredits: 0,
        minVoiceCredits: 50,
        offerExtraId: [],
        phoneCategoryId: [],
        phoneId: [],
        phoneOperatingSystemId: [],
        phoneVariantId: [],
        providerId: [],
        shopId: []
      },
      initialShow: true,
      initialSort: SORTS.popular,
      extraOfferLineIds: [],
      pagination: false,
      paginationPerPage: 10,
      show: true,
      preSelectPhoneFromPhoneGroup: false,
      showPrice: true
    },
    simOnly: {
      collapsibleResults: false,
      collapsibleResultsLimit: 5,
      filters: {
        mainFilters: [
          FILTER_NAMES.dataCredits,
          FILTER_NAMES.voiceCredits,
          FILTER_NAMES.monthlyFee
        ],
        mobileFilters: [FILTER_NAMES.dataCredits, FILTER_NAMES.voiceCredits],
        secondaryFilters: [
          FILTER_NAMES.providers,
          FILTER_NAMES.currentProvider,
          { name: FILTER_NAMES.offerExtraGroups, order: [] },
          FILTER_NAMES.contractTermInMonths,
          FILTER_NAMES.dataSpeedDown
        ]
      },
      fullComparatorUrl: null,
      initialFilter: {
        contractTermInMonths: [],
        currentProviderId: null,
        dataSpeedGen: [],
        isIndependent: null,
        isRetention: false,
        limit: 20,
        maxMonthlyFee: 150,
        minDataCredits: 1000,
        minDataSpeedDown: 0,
        minSmsCredits: 0,
        minVoiceCredits: 50,
        offerExtraId: [],
        providerId: [],
        shopId: []
      },
      initialShow: false,
      initialSort: SORTS.bestTco,
      extraOfferLineIds: [],
      pagination: false,
      paginationPerPage: 10,
      show: true
    }
  },
  [WIDGETS.inDepth_default_combi.id]: {
    phoneOffer: { preSelectPhoneFromPhoneGroup: true },
    proposition: { preSelectPhoneFromPhoneGroup: true },
    simOnly: {}
  },
  [WIDGETS.inDepth_default_phoneOffer.id]: {
    phoneOffer: { preSelectPhoneFromPhoneGroup: true, show: true },
    proposition: { show: false },
    simOnly: { show: false }
  },
  [WIDGETS.inDepth_default_proposition.id]: {
    phoneOffer: { show: false },
    proposition: { preSelectPhoneFromPhoneGroup: true, show: true },
    simOnly: { show: false }
  },
  [WIDGETS.inDepth_default_simOnly.id]: {
    phoneOffer: { show: false },
    proposition: { show: false },
    simOnly: { show: true }
  },
  [WIDGETS.topList_default_proposition.id]: {
    phoneOffer: { show: false },
    proposition: {
      filters: {
        mainFilters: [],
        mobileFilters: [],
        secondaryFilters: []
      },
      initialFilter: { limit: 5 },
      show: true
    },
    simOnly: { show: false }
  },
  [WIDGETS.topList_default_simOnly.id]: {
    phoneOffer: { show: false },
    proposition: { show: false },
    simOnly: {
      filters: {
        mainFilters: [],
        mobileFilters: [],
        secondaryFilters: []
      },
      initialFilter: { limit: 5 },
      show: true
    }
  },
  [WIDGETS.topList_inArticle_proposition.id]: {
    phoneOffer: { show: false },
    proposition: {
      filters: {
        mainFilters: [],
        mobileFilters: [],
        secondaryFilters: []
      },
      initialFilter: { limit: 3 },
      show: true
    },
    simOnly: { show: false }
  },
  [WIDGETS.topList_inArticle_simOnly.id]: {
    phoneOffer: { show: false },
    proposition: { show: false },
    simOnly: {
      filters: {
        mainFilters: [],
        mobileFilters: [],
        secondaryFilters: []
      },
      initialFilter: { limit: 3 },
      show: true
    }
  }
};
